import { proxy } from 'valtio';

export const mobileNav = proxy({
  isOpen: false,
});
